export const cars = [
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "popular",
    rating: "4.8",
    reviews: "12",
    cost: "$1000 total",
    src: "/images/content/cars-pic-1.jpg",
    srcSet: "/images/content/cars-pic-1@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$420",
    category: "white",
    categoryText: "popular",
    rating: "4.9",
    reviews: "20",
    cost: "$1100 total",
    src: "/images/content/cars-pic-2.jpg",
    srcSet: "/images/content/cars-pic-2@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "popular",
    rating: "4.5",
    reviews: "120",
    cost: "$700 total",
    src: "/images/content/cars-pic-3.jpg",
    srcSet: "/images/content/cars-pic-3@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$240",
    category: "white",
    categoryText: "popular",
    rating: "5.0",
    reviews: "44",
    cost: "$1111 total",
    src: "/images/content/cars-pic-4.jpg",
    srcSet: "/images/content/cars-pic-4@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "popular",
    rating: "4.8",
    reviews: "12",
    cost: "$1000 total",
    src: "/images/content/cars-pic-5.jpg",
    srcSet: "/images/content/cars-pic-5@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$420",
    category: "white",
    categoryText: "popular",
    rating: "4.9",
    reviews: "20",
    cost: "$1100 total",
    src: "/images/content/cars-pic-6.jpg",
    srcSet: "/images/content/cars-pic-6@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "popular",
    rating: "4.5",
    reviews: "120",
    cost: "$700 total",
    src: "/images/content/cars-pic-7.jpg",
    srcSet: "/images/content/cars-pic-7@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$240",
    category: "white",
    categoryText: "popular",
    rating: "5.0",
    reviews: "44",
    cost: "$1111 total",
    src: "/images/content/cars-pic-8.jpg",
    srcSet: "/images/content/cars-pic-8@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "popular",
    rating: "4.8",
    reviews: "12",
    cost: "$1000 total",
    src: "/images/content/cars-pic-9.jpg",
    srcSet: "/images/content/cars-pic-9@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$420",
    category: "white",
    categoryText: "popular",
    rating: "4.9",
    reviews: "20",
    cost: "$1100 total",
    src: "/images/content/cars-pic-10.jpg",
    srcSet: "/images/content/cars-pic-10@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "136 - 150, Pentonville Road, Kings Cross, London, UK",
        icon: "route",
      },
      {
        title: "1 Supplier",
        icon: "user",
      },
    ],
  },
];

export const cars1 = [
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "excellent",
    rating: "4.8",
    reviews: "12",
    cost: "$1000 total",
    src: "/images/content/cars-photo-1.jpg",
    srcSet: "/images/content/cars-photo-1@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "Vauxhall Corsa",
    priceOld: "/day",
    priceActual: "$420",
    category: "white",
    categoryText: "excellent",
    rating: "4.9",
    reviews: "20",
    cost: "$1100 total",
    src: "/images/content/cars-photo-2.jpg",
    srcSet: "/images/content/cars-photo-2@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "excellent",
    rating: "4.5",
    reviews: "120",
    cost: "$700 total",
    src: "/images/content/cars-photo-3.jpg",
    srcSet: "/images/content/cars-photo-3@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "Vauxhall Corsa",
    priceOld: "/day",
    priceActual: "$240",
    category: "white",
    categoryText: "excellent",
    rating: "5.0",
    reviews: "44",
    cost: "$1111 total",
    src: "/images/content/cars-photo-4.jpg",
    srcSet: "/images/content/cars-photo-4@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "excellent",
    rating: "4.8",
    reviews: "12",
    cost: "$1000 total",
    src: "/images/content/cars-photo-5.jpg",
    srcSet: "/images/content/cars-photo-5@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "Vauxhall Corsa",
    priceOld: "/day",
    priceActual: "$420",
    category: "white",
    categoryText: "excellent",
    rating: "4.9",
    reviews: "20",
    cost: "$1100 total",
    src: "/images/content/cars-photo-6.jpg",
    srcSet: "/images/content/cars-photo-6@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "excellent",
    rating: "4.5",
    reviews: "120",
    cost: "$700 total",
    src: "/images/content/cars-photo-7.jpg",
    srcSet: "/images/content/cars-photo-7@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "Vauxhall Corsa",
    priceOld: "/day",
    priceActual: "$240",
    category: "white",
    categoryText: "excellent",
    rating: "5.0",
    reviews: "44",
    cost: "$1111 total",
    src: "/images/content/cars-photo-8.jpg",
    srcSet: "/images/content/cars-photo-8@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
  {
    title: "London - Kings Cross",
    priceOld: "/day",
    priceActual: "$300",
    category: "white",
    categoryText: "excellent",
    rating: "4.8",
    reviews: "12",
    cost: "$1000 total",
    src: "/images/content/cars-photo-9.jpg",
    srcSet: "/images/content/cars-photo-9@2x.jpg",
    url: "/cars-product",
    options: [
      {
        title: "London - Kings Cross",
        icon: "route",
      },
    ],
  },
];
